import React from "react";
import { useEffect, useState } from 'react';
import { Form, Button, Table, Col, Row } from 'react-bootstrap';
import { capitalizeFirstLetter } from '../Shared/Helpers';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactDatetime from "react-datetime";

const StepFour = ({ handleNext, handleBack, storedData, stepNum, jobType }) => {

    const [otherQualificationsRecords, setOtherQualificationsRecords] = useState([]);
    const [errors, setErrors] = useState({});

    const handleCapitalWord = (index, field, value) => {
        updateQualificationRecord(index, field, capitalizeFirstLetter(value));
    };

    const addOtherQualificationRecord = () => {
        const newRecord = {
            courseTitle: '',
            qualificationAwarded: '',
            gradeOrResult: '',
            expiryDate: new Date(),
        };
        setOtherQualificationsRecords([...otherQualificationsRecords, newRecord]);
    };

    const updateQualificationRecord = (index, field, value) => {
        setOtherQualificationsRecords(records => records.map((record, i) => i === index ? { ...record, [field]: value } : record));
    };


    //const updateQualificationRecord = (index, field, value) => {
    //    const updatedRecord = {
    //        ...otherQualificationsRecords[index],
    //        [field]: value
    //    };
    //    const updatedRecords = [...otherQualificationsRecords];
    //    updatedRecords[index] = updatedRecord;
    //    setOtherQualificationsRecords(updatedRecords);
    //};

    const removeQualificationRecord = (index) => {
        const updatedRecords = [...otherQualificationsRecords];
        updatedRecords.splice(index, 1);
        setOtherQualificationsRecords(updatedRecords);
    };


    function validateRecords() {
        const errors = {};
        otherQualificationsRecords.forEach((record, index) => {
            if (isEmpty(record.courseTitle)) {
                errors[`courseTitle${index}`] = 'Course Title is required';
            }
            if (isEmpty(record.qualificationAwarded)) {
                errors[`qualificationAwarded${index}`] = 'Qualification Awarded is required';
            }
            if (isEmpty(record.gradeOrResult)) {
                errors[`gradeOrResult${index}`] = 'Grade or result is required';
            }
        });
        return errors;
    };

    const handleNextCommand = () => {
        try {

            // no qualifications Records - skip to next stage
            if (otherQualificationsRecords.length === 0) {
                handleNext(otherQualificationsRecords);
                return;
            }

            const logErrors = validateRecords();

            if (!Object.values(logErrors).some(Boolean)) {
                console.log(otherQualificationsRecords);
                setErrors([]);
                handleNext(otherQualificationsRecords);
            } else {
                setErrors(logErrors);
            }
        } catch (e) {
            console.log(e);
        }
    };

    // ## HOOKS ##
    useEffect(() => {
        if (!isEmpty(storedData)) {
            setOtherQualificationsRecords(storedData);
        }
    }, []);


    return (
        <Row>
            <div>
                <Col sm={12} md={12}>
                    <h2 >{stepNum} Other Qualifications</h2>
             
                    <p>(Have you undertaken any training / professional courses relevant to the position applied for?Eg.CSR, CPC, First Aid, Manual Handling, Plant certificates. If yes, please give details)</p>
                  

                </Col>
                {/*{errors && (*/}
                {/*    <Form.Text className="text-danger">*/}
                {/*        <span className="star">*</span>*/}
                {/*        Please note that this section is optional.*/}
                {/*        If you do not possess any additional qualifications,*/}
                {/*        please remove the relevant records before proceeding to the next section.*/}
                {/*    </Form.Text>*/}
                {/*)}*/}
                <div className="table-responsive">
                    <Table striped bordered>
                        <thead>
                            <tr>
                                <th>Course Title</th>
                                <th>Qualification Awarded</th>
                                <th>Grade/ Result</th>
                                <th>Expiry Date (Only If applicable)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {otherQualificationsRecords?.map((record, index) => (
                                <tr key={index}>
                                    <td data-label="Course Title">
                                        <Form.Control
                                            className={errors[`courseTitle${index}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                            type="text"
                                            maxLength="200"
                                            value={record.courseTitle}
                                            onBlur={(e) => handleCapitalWord(index, "courseTitle", e.target.value)}
                                            onChange={(e) => {
                                                updateQualificationRecord(index, 'courseTitle', e.target.value);
                                                if (errors[`courseTitle${index}`]) {
                                                    setErrors({ ...errors, [`courseTitle${index}`]: "" });
                                                }
                                            }}
                                        />
                                        {errors[`courseTitle${index}`] && <Form.Text className="text-danger"> <span className="star">*</span> {errors[`courseTitle${index}`]} </Form.Text>}
                                    </td>
                                    <td data-label="Qualification Awarded">
                                        <Form.Control
                                            className={errors[`qualificationAwarded${index}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                            type="text"
                                            maxLength="200"
                                            value={record.qualificationAwarded}
                                            onBlur={(e) => handleCapitalWord(index, "qualificationAwarded", e.target.value)}
                                            onChange={(e) => {
                                                updateQualificationRecord(index, 'qualificationAwarded', e.target.value);
                                                if (errors[`qualificationAwarded${index}`]) {
                                                    setErrors({ ...errors, [`qualificationAwarded${index}`]: "" });
                                                }
                                            }}
                                        />
                                        {errors[`courseTitle${index}`] && <Form.Text className="text-danger"> <span className="star">*</span> {errors[`courseTitle${index}`]} </Form.Text>}
                                    </td>
                                    <td data-label="Grade / Result">
                                        <Form.Control
                                            className={errors[`gradeOrResult${index}`] ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                            type="text"
                                            maxLength="200"
                                            value={record.gradeOrResult}
                                            onBlur={(e) => handleCapitalWord(index, "gradeOrResult", e.target.value)}
                                            onChange={(e) => {
                                                updateQualificationRecord(index, 'gradeOrResult', e.target.value);
                                                if (errors[`gradeOrResult${index}`]) {
                                                    setErrors({ ...errors, [`gradeOrResult${index}`]: "" });
                                                }
                                            }}
                                        />
                                        {errors[`gradeOrResult${index}`] && <Form.Text className="text-danger"> <span className="star">*</span> {errors[`gradeOrResult${index}`]} </Form.Text>}
                                    </td>

                                    <td data-label="Expiry Date (Only If applicable)">
                                        <Form.Group>
                                            <ReactDatetime
                                                dateFormat="DD/MM/YYYY"
                                                timeFormat={false}
                                                onChange={(e) => updateQualificationRecord(index, 'expiryDate', e)}
                                                value={record?.expiryDate ? new Date(record.expiryDate).toLocaleDateString('en-gb', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric'
                                                }).replace(/\//g, '/') : new Date().toLocaleDateString('en-gb', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric'
                                                }).replace(/\//g, '/')}
                                            ></ReactDatetime>
                                        </Form.Group>
                                    </td>

                                    <td>
                                        <Button variant="warning" onClick={() => removeQualificationRecord(index)}>Remove</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr style={{ backgroundColor: 'rgba(129, 105, 74, 0.1)' }}>
                                <td colSpan="5" style={{ textAlign: 'right' }}>
                                    <Button onClick={addOtherQualificationRecord} >
                                        <i className="fa fa-plus"></i>{' '}
                                        Add Qualification Record
                                    </Button>

                                </td>
                            </tr>
                        </tfoot>
                    </Table>
                </div>
            </div>

            <Row>
                <Col sm={12} className="d-flex justify-content-between mt-3">
                    <Button className="btn-lg btn-shadow" variamt="danger" onClick={handleBack}>Back</Button>
                    <Button className="btn-lg btn-shadow" variamt="success" onClick={handleNextCommand}>Next</Button>
                </Col>
            </Row>

        </Row >
    );
}

export default StepFour;
